<template>
	<nav aria-label="Page navigation" id="pagination">
		<ul class="pagination justify-content-center">
			<li class="page-item">
				<a class="page-link" href="#" @click="prevPage">Forrige</a>
			</li>
			<template v-for="i in pages" :key="i">
				<li
					v-if="shouldDisplay(i)"
					:class="{
						'page-item': true,
						active: i === page,
					}"
				>
					<a class="page-link" href="#" @click="changePage(i)">{{
						i
					}}</a>
				</li>
				<li v-else-if="shouldDisplayEllipsis(i)">
					<span class="page-link">.....</span>
				</li>
			</template>
			<li class="page-item">
				<a href="#" class="page-link" @click="nextPage">Næste</a>
			</li>
		</ul>
	</nav>
</template>
<script setup>
import { ref, watchEffect } from "vue";
const emit = defineEmits(["pageChanged"]);
const props = defineProps({
	pages: {
		required: true,
		type: Number,
	},
	page: {
		required: true,
		type: Number,
	},
});
const pages = ref(props.pages);
const page = ref(props.page);
watchEffect(() => {
	pages.value = props.pages;
	page.value = props.page;
});
const prevPage = () => {
	if (page.value > 1) {
		page.value--;
	}
	emit("pageChanged", page.value);
	// Optionally, you can add logic here to fetch data for the previous page
};
const nextPage = () => {
	if (page.value < pages.value) {
		page.value++;
	}
	emit("pageChanged", page.value);
	// Optionally, you can add logic here to fetch data for the next page
};
const changePage = (pageNumber) => {
	page.value = pageNumber;
	// Optionally, you can add logic here to fetch data for the selected page
	emit("pageChanged", pageNumber);
};
const shouldDisplay = (pageNumber) => {
	return (
		pageNumber <= 2 ||
		pageNumber > pages.value - 2 ||
		Math.abs(pageNumber - page.value) < 3
	);
};

const shouldDisplayEllipsis = (pageNumber) => {
	return Math.abs(pageNumber - page.value) === 3;
};
</script>
